import configs from '../configs';
import request from './request';

function signIn(data) {
	return request({
		url: '/agents/sign-in',
		method: 'POST',
		data,
	});
}

function signOut() {
	window.localStorage.removeItem('at');
	window.localStorage.removeItem('rt');
	window.localStorage.removeItem('tt');
	window.localStorage.removeItem(configs.context.main);
	window.localStorage.removeItem(configs.context.user);
	window.localStorage.removeItem('originUserInfo'); // created on view as
	window.__history.push(configs.loginPath);
}

function updatePassword(data) {
	return request({
		url: '/agents/password',
		method: 'PUT',
		data,
	});
}

function getProfile() {
	return request({
		url: '/agents/profile',
		method: 'GET',
	});
}

export default {
	signIn,
	signOut,
	getProfile,
	updatePassword,
};
